import Checkout from './checkout';
import ErrorScreen from './ErrorScreen';
import RestaurantDetailsScreen from './RestaurantDetailsScreen';
import PageNotFound from './PageNotFound';
import OrderDetailsScreen from './OrderDetailsScreen';
import OrderBasketScreen from './OrderBasketScreen';
import RewardsScreen from './RewardsScreen';
import UploadGoogleReviewScreen from './UploadGoogleReviewScreen';
import GiftCardsCheckoutScreen from './GiftCardsCheckoutScreen';
import GiftCardsOrderDetailsScreen from './GiftCardsOrderDetailsScreen';
import Legal from './Legal';

export default {
  Checkout,
  ErrorScreen,
  RestaurantDetailsScreen,
  PageNotFound,
  OrderDetailsScreen,
  OrderBasketScreen,
  RewardsScreen,
  UploadGoogleReviewScreen,
  GiftCardsCheckoutScreen,
  GiftCardsOrderDetailsScreen,
  Legal,
};
